<shared-core-loading-page [loadingProgress]="this.pageImageService.loadingProgress()" />
@if (loadingComplete()) {
  <div class="flex h-full flex-col">
    <ct-shared-header [ctBatch]="batches()[0]" />
    <ng-template let-page #ocrOverlay>
      <ct-extraction-text-selection-overlay
        class="absolute top-0 right-0 bottom-0 left-0"
        ctExtractionLassoSelection
        externalDocumentPreviewOcrSelection
        #ocr="ocrSelection"
        [selectedWordsRect]="ocr.selectedWordRects()"
        [lasso]="ocr.lasso()"
        [dimension]="dimensionService.dimensionsByPageId()[page.id]"
        [showTextSelectionOverlay]="true"
        [page]="page"
        [isOcrReady]="ocrInitialized()" />
    </ng-template>
    <ct-shared-document-preview
      [documentClassFilterEnabled]="true"
      [pageOverlayTemplate]="ocrOverlay"
      [isPreviewListExpandedInitially]="true"
      [ctBatch]="batches()[0]"
      [allDocuments]="documents()"
      class="min-h-0 grow p-2" />
  </div>
}
